import React from 'react'
import LinkButton from '@components/common/LinkButton'
import BasicCard from '../../productcards/BasicCard'
import imgShopBestSeller from '@images/Home/shop-best-sellers.webp'
import imgNewArrivals from '@images/Home/shop-new-arrivals.webp'

const MegaMenu = ({handleMegaMenu}) => {

  const swimMenu = [
    {label: 'All Swim', url: '/collections/all'},
    {label: 'New Arrivals', url: '/collections/new-arrivals'},
    {label: 'Tops', url: '/collections/tops'},
    {label: 'Bottoms', url: '/collections/bottoms'},
    {label: 'One Piece', url: '/collections/one-piece-swimwear'},
    {label: 'Solids', url: '/collections/solids'},
    {label: 'Textured', url: '/collections/the-textured-collection'},
    {label: 'Tankinis', url: '/collections/tankinis'},
  ]

  const apparelMenu = [
    {label: 'All Beachwear', url: '/collections/beachwear'},
    {label: 'All Accessories', url: '/collections/accessories'},
    {label: 'Tanks & Tees', url: '/collections/tanks-tees'},
    {label: 'Dresses & Skirts', url: '/collections/dresses-skirts'},
    {label: 'Shorts', url: '/collections/shorts'},
    {label: 'Bags', url: '/collections/bags'},
    {label: 'Men\'s Collection', url: '/collections/mens-collection'},
    {label: 'Matching Couple Suits', url: '/collections/his-hers'},
  ]

  const collectionMenu = [
    //{label: 'All Collections', url: '/collections/all'},
    {label: 'Island Life', url: '/collections/the-ashley-kelly-edit-island-life/'},
    {label: 'Sunsoaked', url: '/collections/the-sunsoaked-collection/'},
    {label: 'Butter Yellow', url: '/collections/the-butter-yellow-collection/'},
    {label: 'Wish You Were Here', url: '/collections/the-wish-you-were-here-collection/'},
    {label: 'Red Hot Gloss', url: '/collections/the-red-hot-gloss-collection'},
    {label: 'Palacio Del Sol', url: '/collections/the-palacio-del-sol-collection'},
	{label: 'Agua Fresca', url: '/collections/the-agua-fresca-collection'},
    {label: 'Henna', url: '/collections/the-henna-collection'},
    {label: 'La Playa Vol. 3', url: '/collections/the-la-playa-vol-3-collection'},
    //{label: 'La Vie Boheme', url: '/collections/the-la-vie-boheme-collection'},
    //{label: 'City Sweetheart', url: '/collections/the-city-sweetheart-collection'},
    // {label: 'Primavera', url: '/collections/the-primavera-collection'},
    // {label: 'Banana Bunch', url: '/collections/the-banana-bunch-collection'},
    //{label: 'Wild Hearts', url: '/collections/the-wild-hearts-collection'},
    // {label: 'Solids', url: '/collections/solids'},
    // {label: 'Core', url: '/collections/the-core-collection'},
  ]

  return (
    <React.Fragment>
      <div className="w-auto lg:w-full bg-white absolute z-[49]" onMouseLeave={() => handleMegaMenu(false)}>
        <div className="hidden lg:grid grid-cols-1 lg:grid-cols-2 max-w-[1440px] px-4 xl:px-40 lg:px-10 py-12 h-max lg:h-auto overflow-y-auto mx-auto">
          <div className="grid grid-flow-col">
            <div className="">
              <button onClick={() => {}}>
                <h3 className='mb-4'>SWIM</h3>
              </button>
              <div className="flex flex-col gap-y-2">
                {swimMenu.map((item, index) => {
                  return <LinkButton className={'hover:underline hover:underline-offset-2'} label={item.label} key={`swim-${index}`} to={item.url} ariaLabel={item?.label} />;
                })}
              </div>
            </div>

            <div className="">
              <button onClick={() => {}}>
                <h3 className='mb-4'>APPAREL</h3>
              </button>
              <div className="flex flex-col gap-y-2">
                {apparelMenu.map((item, index) => {
                  return <LinkButton className={'hover:underline hover:underline-offset-2'} label={item.label} key={`apparel-${index}`} to={item.url} ariaLabel={item?.label} />;
                })}
              </div>
            </div>

            <div className="">
              <button onClick={() => {}}>
                <h3 className='mb-4'>COLLECTION</h3>
              </button>
              <div className="flex flex-col gap-y-2">
                {collectionMenu.map((item, index) => {
                  return <LinkButton className={'hover:underline hover:underline-offset-2'} label={item.label} key={`collection-${index}`} to={item.url} ariaLabel={item?.label} />;
                })}
              </div>
            </div>
          </div>

          <div className='grid grid-flow-col gap-x-4 pt-6 lg:pt-0 justify-center lg:justify-start'>
            <BasicCard
              data={{
                label: "SHOP BEST SELLERS",
                image: imgShopBestSeller,
              }}
              link={'/collections/bestsellers/'}
              className="relative w-full xl:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer"
              ariaLabel='SHOP BEST SELLERS'
            />

            <BasicCard
              data={{
                label: "SHOP NEW ARRIVALS",
                image: imgNewArrivals,
              }}
              link={'/collections/new-arrivals/'}
              className="relative w-full xl:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer"
              ariaLabel='SHOP NEW ARRIVALS'
            />
          </div>
        </div>

        {/* <section className='flex lg:hidden'>
          test
        </section> */}
      </div>
    </React.Fragment>
  );
}

export default MegaMenu